import { FormlyFieldConfig } from '@ngx-formly/core';
import {
  advancedSection,
  COMMON_FIELD_CONFIGS,
  LOOKUP_LIST_ID_FIELD,
  OPTIONS_EDITOR_FIELD,
  OPTIONS_SOURCE_TOGGLE_FIELD,
} from './field-config-shared';

/**
 * checkbox-group: type → label → required → options → [Advanced: width, prefillLastValue]
 *
 * allowMultiple is always true for checkbox-groups; set at save time.
 * Labels are user-generated content and are NOT translated.
 * Duplicate labels show an inline warning (non-blocking).
 */
export function getCheckboxGroupFieldConfigFields(): FormlyFieldConfig[] {
  return [
    COMMON_FIELD_CONFIGS['type'],
    COMMON_FIELD_CONFIGS['label'],
    COMMON_FIELD_CONFIGS['required'],
    OPTIONS_SOURCE_TOGGLE_FIELD,
    LOOKUP_LIST_ID_FIELD,
    OPTIONS_EDITOR_FIELD,
    advancedSection(COMMON_FIELD_CONFIGS['width'], COMMON_FIELD_CONFIGS['prefillLastValue']),
  ];
}
